import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import { useCheckoutController } from '~/src/features/checkout/controllers/useCheckoutController'

export function CheckoutPage() {
  const { cart, customer, error, form, otpStep, pendingVerification, submitting, submittedRequest, submitLabel, actions } = useCheckoutController()

  if (submittedRequest) {
    return (
      <div className="shop-section checkout-success">
        <div className="shop-card">
          <h1>Solicitud enviada</h1>
          <p>Tu solicitud ha sido enviada. El staff de Perfect Scent se contactará en breve contigo para completar tu compra.</p>
          <p className="shop-muted">Referencia: {submittedRequest.number}</p>
          <div className="checkout-success__actions">
            <Link className="shop-button" to="/">Volver al catálogo</Link>
            <Link className="shop-button" to="/cuenta">Ir a mi cuenta</Link>
          </div>
        </div>
      </div>
    )
  }

  if (cart.items.length === 0) {
    return <Navigate to="/carrito" replace />
  }

  return (
    <div className="shop-section checkout-layout">
      <form className="shop-form" onSubmit={actions.handleSubmit}>
        <h1>Checkout</h1>
        {error && <p className="shop-error">{error}</p>}
        <input
          className="shop-input"
          placeholder="Nombre completo"
          required
          value={form.customer_name}
          onChange={(event) => actions.handleFieldChange('customer_name', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Correo"
          required
          inputMode="email"
          autoComplete="email"
          pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
          title="Ingresa un correo electrónico válido"
          value={form.email}
          onChange={(event) => actions.handleFieldChange('email', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Teléfono"
          required
          inputMode="numeric"
          maxLength={10}
          value={form.phone_number}
          onChange={(event) => actions.handleFieldChange('phone_number', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Calle y número"
          required
          value={form.shipping_address.line_1}
          onChange={(event) => actions.handleShippingAddressChange('line_1', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Colonia"
          value={form.shipping_address.line_2}
          onChange={(event) => actions.handleShippingAddressChange('line_2', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Ciudad"
          required
          value={form.shipping_address.city}
          onChange={(event) => actions.handleShippingAddressChange('city', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Estado"
          required
          value={form.shipping_address.state}
          onChange={(event) => actions.handleShippingAddressChange('state', event.target.value)}
        />
        <input
          className="shop-input"
          placeholder="Código postal"
          required
          value={form.shipping_address.zip_code}
          onChange={(event) => actions.handleShippingAddressChange('zip_code', event.target.value)}
        />
        <textarea className="shop-input" placeholder="Notas del pedido" value={form.notes} onChange={(event) => actions.handleFieldChange('notes', event.target.value)} />
        {!customer && otpStep === 'verify' ? (
          <>
            <p>
              Ingresa el codigo enviado a {pendingVerification?.masked_destination || form.email}
            </p>
            <input
              className="shop-input"
              placeholder="Codigo de verificacion"
              inputMode="numeric"
              maxLength={6}
              value={form.code}
              onChange={(event) => actions.handleFieldChange('code', event.target.value)}
            />
            <button className="shop-link-button" type="button" onClick={actions.handleResendCode}>Reenviar codigo</button>
          </>
        ) : null}
        <button type="submit" disabled={submitting}>{submitting ? 'Procesando...' : submitLabel}</button>
      </form>
      <aside className="checkout-summary">
        <h2>Resumen</h2>
        {cart.items.map((item) => (
          <div key={item.id} className="cart-row compact">
            <span>{item.product.name} x {item.quantity}</span>
            <strong>${item.total_price.toFixed(2)}</strong>
          </div>
        ))}
        <div className="cart-summary">
          <span>Total</span>
          <strong>${(cart.subtotal_amount || 0).toFixed(2)}</strong>
        </div>
      </aside>
    </div>
  )
}
